import { Controller } from "stimulus";

class ScrollToTopController extends Controller {
  static targets = ["button"];

  connect() {
    window.addEventListener("scroll", this.#scrollListener);
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  #scrollListener = () => {
    const isScrolled = window.scrollY > 0;
    this.#toggleButtonClasses(isScrolled);
  };

  #toggleButtonClasses(isScrolled) {
    const button = this.buttonTarget;

    button.classList.toggle("-tw-bottom-16", !isScrolled);
    button.classList.toggle("lg:tw-bottom-36", isScrolled);
    button.classList.toggle("tw-bottom-20", isScrolled);
    button.classList.toggle("tw-opacity-0", !isScrolled);
    button.classList.toggle("tw-opacity-100", isScrolled);
  }
}

Stimulus.register("scroll-to-top", ScrollToTopController);
